import ScrollObserver from 'helpers/scroll-observer';

export class HeaderShadow {

    private headerObj !: HTMLElement | null;
    private shadowAttached = false;

    public constructor() {
        this.init();
    }

    private init() : void {
        this.initHeaderShadow();
    }

    /**
     * Retrieves with the header element
     * @private
     */
    private getHeader() : HTMLElement|null {
        if (typeof this.headerObj === 'undefined') {
            this.headerObj = document.querySelector('.fixed-header');
        }

        return this.headerObj;
    }

    /**
     * Initialize the shadow effect under header
     * when there is no promotion
     * @private
     */
    private initHeaderShadow() : void {
        const activeCampaignHere = document.querySelector('.active-campaign-here');
        if (!activeCampaignHere) {
            this.initScrollObserver();
        }
    }

    private initScrollObserver() : void {
        new ScrollObserver(
            () => document.querySelectorAll('.fixed-header-sentinel'),
            {
                onIntersectionEntry: (entry : IntersectionObserverEntry) => this.intersectionObserverCallback(entry),
                onScrollEvent: () => this.scrollEventListenerCallback(),
            },
        );
    }

    private intersectionObserverCallback(entry : IntersectionObserverEntry) : void {
        this.getHeader()?.classList.toggle('fixed-header-shadow', entry.intersectionRatio < 1);
    }

    private scrollEventListenerCallback() : void {
        const hasScrolled = window.scrollY > 0;
        if (hasScrolled !== this.shadowAttached) {
            this.getHeader()?.classList.toggle('fixed-header-shadow', hasScrolled);
            this.shadowAttached = hasScrolled;
        }
    }

}
